module.exports = __webpack_public_path__ + "static/testi-1-2-e22c14e193af88e8f89304f17f28af19.jpg";